import { Sparkles } from "lucide-react";
import { useI18n } from "@/context/I18nContext";

/**
 * Receipt preview with a cyan scanning line sweeping vertically while the
 * image is being analysed. Animates only transform/opacity (see index.css
 * `.scan-effect-*`). Rendered exclusively during the "scanning" stage; the
 * parent unmounts it when analysis finishes.
 */
export function ScanEffect({ src }) {
  const { t } = useI18n();
  return (
    <div className="card-base p-6 md:p-8 text-center" data-testid="receipt-scanning">
      <div className="scan-effect-frame mx-auto" data-testid="receipt-scan-effect">
        {src ? (
          <img src={src} alt="" className="scan-effect-image" decoding="async" />
        ) : (
          <div className="scan-effect-image bg-white/5" />
        )}
        <div className="scan-effect-dim" />
        <div className="scan-effect-grid" />
        <div className="scan-effect-beam" aria-hidden="true">
          <div className="scan-effect-beam-band" />
          <div className="scan-effect-beam-line" />
        </div>
        <span className="scan-effect-corner tl" /><span className="scan-effect-corner tr" />
        <span className="scan-effect-corner bl" /><span className="scan-effect-corner br" />
      </div>
      <p className="font-display font-semibold text-lg flex items-center justify-center gap-2 mt-5 text-cyan-100" data-testid="receipt-scan-status" aria-live="polite">
        <Sparkles className="text-cyan-300 animate-pulse-glow" style={{ width: 18, height: 18 }} /> {t("scan.analyzing")}
      </p>
      <p className="text-sm text-muted-foreground mt-1">{t("scan.readingDesc")}</p>
    </div>
  );
}
